import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Typography } from "@mui/material";
import { getCashfreeResponse } from "redux/actions/UserCashFreeAction";
import PaymentFailed from "./PaymentFailed";
import Loader from "components/loader/Loader";
import confirmTrip from "assets/images/confirmTrip.svg";

function ConfirmRide() {
  const navigate = useNavigate()
  const {state} = useLocation();
  const dispatch = useDispatch();
  const [searchParams,setSearchParams] = useSearchParams();
  const tripId = searchParams.get('tripId')
  const tripData = useSelector((state) => state?.userCashFreeResponse?.userCashFreeResponse?.data);
  const tripLoader = useSelector((state) => state?.userCashFreeResponse?.loading)
  const tripDataError = useSelector((state) => state?.userCashFreeResponse?.error);
  const onRideDetails = () => {
    if(status){
      navigate('/home')
    }
    else{
      navigate(`/rideDetails?tripId=${tripData?.id}&type=${tripData?.type}`,{state:{tripCheckout:tripData,rideStatus:true}})
    }
  }
useEffect(()=>{
  sessionStorage.clear()
},[])
  const onHome = () => {
    navigate('/home')
  }
  useEffect(() =>{
    const payload = {
      tripId:tripId
    }
    if(tripId){
      dispatch(getCashfreeResponse(payload))
    }
  },[tripId])
const status = state?.cancelTrip;
  return (
    <div>
      {tripLoader ? <Loader /> : tripDataError ? <PaymentFailed/> :
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="textAlign mapStyleh80 myRideMain"
      >
        <Grid item>
          <img className='w250' src={confirmTrip} alt="confirmTrip" />
        </Grid>
        <Grid item className="alignTextCenter">
          <Typography className="fontHeading colorBlue fontMedium">
           {status ? 'Trip Cancelled Successfully' : 'Ride Confirmed'} 
          </Typography>
          <Typography className="font20 fontMedium marginTop15">
            {status ? 'Your trip has been cancelled. Refund will be processed soon.':'The booking request has been sent'}
          </Typography>
          <Typography className="font18 colorGrey marginTop15">
           {!status && 'We will assign your driver before 60 min of the trip'} 
          </Typography>
          <Button className="buttonEnabled" onClick={onRideDetails}>{status ? 'Ride Book': 'Ride Details'}</Button>
          <Button className="homeBtn" onClick={onHome}>Home</Button>
        </Grid>
      </Grid>
      }
    </div>
  );
}

export default ConfirmRide;
